import type { App } from 'vue'
import type { Router } from 'vue-router'

import { updatePreferences } from '@vben/preferences'
import { useAccessStore } from '@vben/stores'

type MicroAppWindow = Window & {
  rawWindow?: Window
}

export function getMicroApp() {
  // @ts-ignore xxx
  return window?.microApp?.getGlobalData()?.microApp as any
}

export function isInMicroApp() {
  // @ts-ignore xxx
  return !!window.__MICRO_APP_ENVIRONMENT__
}

export function getMicroAppName() {
  // @ts-ignore xxx
  return window.__MICRO_APP_NAME__ ?? 'Base'
}

export function getMicroAppBaseRoute() {
  // @ts-ignore xxx
  return window.__MICRO_APP_BASE_ROUTE__ ?? '/'
}

export function getNavigationWindow() {
  return (window as MicroAppWindow).rawWindow ?? window
}

export function setupMicroApp(app: App, router: Router) {
  const _microApp = getMicroApp()
  _microApp.onDataChange(getMicroAppName(), (data: any) => {
    console.log('data changed:', data)
    const { fullPath } = data

    if (fullPath) {
      router.replace(fullPath)
    }
  })

  _microApp.onGlobalDataChange((data: any) => {
    console.log('global data changed:', data)

    const { token, preferences, accessCodes } = data

    if (token) {
      app.runWithContext(() => {
        const accessStore = useAccessStore()
        accessStore.setAccessToken(token)
        if (accessCodes && accessCodes.length > 0) {
          accessStore.setAccessCodes(accessCodes)
        }
      })
    }

    if (preferences?.theme?.mode) {
      updatePreferences({
        theme: {
          mode: preferences?.theme?.mode,
        },
      })
    }
  })
}
